import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Box,
    HStack,
    Text,
    Kbd,
} from '@chakra-ui/react';

interface KeyboardShortcutsModalProps {
    isOpen: boolean;
    onClose: () => void;
    modifierLabel: 'Cmd' | 'Ctrl';
}

interface ShortcutRow {
    keys: string[];
    action: string;
}

const renderShortcutKeys = (keys: string[]) => (
    <HStack spacing={1.5} flexWrap="wrap">
        {keys.map((key, index) => (
            <HStack key={`${key}-${index}`} spacing={1.5}>
                {index > 0 && (
                    <Text fontSize="sm" color="gray.400">
                        +
                    </Text>
                )}
                <Kbd
                    fontSize="xs"
                    color="gray.600"
                    bg="gray.100"
                    borderColor="gray.300"
                    px={2}
                    py={1}
                    minW="30px"
                    textAlign="center"
                >
                    {key}
                </Kbd>
            </HStack>
        ))}
    </HStack>
);

const KeyboardShortcutsModal = ({ isOpen, onClose, modifierLabel }: KeyboardShortcutsModalProps) => {
    const shortcutRows: ShortcutRow[] = [
        { keys: ['Shift', modifierLabel, ','], action: 'Settings' },
        { keys: [modifierLabel, '/'], action: 'Keyboard Shortcuts' },
        { keys: [modifierLabel, 'K'], action: 'Search / Ask Carl' },
        { keys: [modifierLabel, '.'], action: 'Open / Close Sidebar' },
    ];

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
            <ModalOverlay />
            <ModalContent
                borderWidth="1px"
                borderColor="gray.300"
                borderRadius="xl"
                overflow="hidden"
                boxShadow="none"
            >
                <ModalHeader
                    bg="gray.100"
                    borderBottomWidth="1px"
                    borderColor="gray.300"
                    fontSize="2xl"
                    fontWeight="semibold"
                    color="gray.800"
                    pr={12}
                >
                    Keyboard Shortcuts
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody p={0} bg="white">
                    <HStack
                        px={5}
                        py={3}
                        bg="gray.50"
                        borderBottomWidth="1px"
                        borderColor="gray.200"
                        align="center"
                    >
                        <Text flex="1" fontSize="xs" color="gray.500" fontWeight="semibold" textTransform="uppercase" letterSpacing="0.05em">
                            Shortcut
                        </Text>
                        <Text flex="1" fontSize="xs" color="gray.500" fontWeight="semibold" textTransform="uppercase" letterSpacing="0.05em">
                            Action
                        </Text>
                    </HStack>

                    {shortcutRows.map((row, index) => (
                        <Box
                            key={row.action}
                            px={5}
                            py={3.5}
                            borderBottomWidth={index === shortcutRows.length - 1 ? 0 : '1px'}
                            borderColor="gray.200"
                        >
                            <HStack align="center">
                                <Box flex="1">
                                    {renderShortcutKeys(row.keys)}
                                </Box>
                                <Text flex="1" fontSize="md" color="gray.700">
                                    {row.action}
                                </Text>
                            </HStack>
                        </Box>
                    ))}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default KeyboardShortcutsModal;
